var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2338_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 11.1667H19.9333C19.7785 10.4143 19.3691 9.73823 18.7741 9.25248C18.179 8.76673 17.4347 8.50097 16.6666 8.5H15.3333C14.5651 8.50097 13.8208 8.76673 13.2258 9.25248C12.6307 9.73823 12.2213 10.4143 12.0666 11.1667H9.99992C9.82311 11.1667 9.65354 11.2369 9.52851 11.3619C9.40349 11.487 9.33325 11.6565 9.33325 11.8333C9.33325 12.0101 9.40349 12.1797 9.52851 12.3047C9.65354 12.4298 9.82311 12.5 9.99992 12.5H10.6666V21.1667C10.6676 22.0504 11.0192 22.8976 11.6441 23.5225C12.269 24.1474 13.1162 24.4989 13.9999 24.5H17.9999C18.8836 24.4989 19.7309 24.1474 20.3558 23.5225C20.9807 22.8976 21.3322 22.0504 21.3333 21.1667V12.5H21.9999C22.1767 12.5 22.3463 12.4298 22.4713 12.3047C22.5963 12.1797 22.6666 12.0101 22.6666 11.8333C22.6666 11.6565 22.5963 11.487 22.4713 11.3619C22.3463 11.2369 22.1767 11.1667 21.9999 11.1667ZM15.3333 9.83333H16.6666C17.0801 9.83384 17.4833 9.96225 17.821 10.201C18.1587 10.4397 18.4142 10.777 18.5526 11.1667H13.4473C13.5856 10.777 13.8412 10.4397 14.1788 10.201C14.5165 9.96225 14.9197 9.83384 15.3333 9.83333ZM19.9999 21.1667C19.9999 21.6971 19.7892 22.2058 19.4141 22.5809C19.0391 22.956 18.5304 23.1667 17.9999 23.1667H13.9999C13.4695 23.1667 12.9608 22.956 12.5857 22.5809C12.2106 22.2058 11.9999 21.6971 11.9999 21.1667V12.5H19.9999V21.1667Z",
    fill: "#E86E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 20.4996C14.8435 20.4996 15.013 20.4293 15.1381 20.3043C15.2631 20.1793 15.3333 20.0097 15.3333 19.8329V15.8329C15.3333 15.6561 15.2631 15.4865 15.1381 15.3615C15.013 15.2365 14.8435 15.1663 14.6667 15.1663C14.4899 15.1663 14.3203 15.2365 14.1953 15.3615C14.0702 15.4865 14 15.6561 14 15.8329V19.8329C14 20.0097 14.0702 20.1793 14.1953 20.3043C14.3203 20.4293 14.4899 20.4996 14.6667 20.4996Z",
    fill: "#E86E7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 20.4996C17.51 20.4996 17.6796 20.4293 17.8046 20.3043C17.9296 20.1793 17.9998 20.0097 17.9998 19.8329V15.8329C17.9998 15.6561 17.9296 15.4865 17.8046 15.3615C17.6796 15.2365 17.51 15.1663 17.3332 15.1663C17.1564 15.1663 16.9868 15.2365 16.8618 15.3615C16.7367 15.4865 16.6665 15.6561 16.6665 15.8329V19.8329C16.6665 20.0097 16.7367 20.1793 16.8618 20.3043C16.9868 20.4293 17.1564 20.4996 17.3332 20.4996Z",
    fill: "#E86E7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2338_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.199e9b2fdb7f5d525cd517794d356884.svg";
export { ForwardRef as ReactComponent };